module.exports = __webpack_public_path__ + "img/sand-dune-decal-17.145fc3dd.png";